export default __webpack_public_path__ + "static/media/User.d459394a.svg";